module.exports = __webpack_public_path__ + "static/media/2019-JL-SWB.8f956a40.jpg";